module.exports = __webpack_public_path__ + "img/5.98391450.jpg";